import { Injectable } from '@angular/core';
import { BaseStoreFacade } from '@city/data-access';
import {
  BreadcrumbMeta,
  CanonicalPageResolver,
  CanonicalUrlOptions,
  PageBreadcrumbResolver,
  PageDescriptionResolver,
  PageLinkService,
  PageMetaResolver,
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  PageType,
  PageTypeResolver,
  WindowRef,
} from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CustomBasePageMetaResolver } from './custom-base-page-meta.resolver';

@Injectable({
  providedIn: 'root',
})
export class StaticPageMetaResolver
  extends PageMetaResolver
  implements
    PageTitleResolver,
    PageBreadcrumbResolver,
    PageDescriptionResolver,
    PageRobotsResolver,
    CanonicalPageResolver,
    PageTypeResolver
{
  constructor(
    private basePageMetaResolver: CustomBasePageMetaResolver,
    private winRef: WindowRef,
    private pageLinkService: PageLinkService,
    private baseStoreFacade: BaseStoreFacade,
  ) {
    super();
    this.pageType = PageType.CONTENT_PAGE;
    this.pageTemplate = 'ContentPage1Template';
  }

  resolveTitle(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveTitle();
  }

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[] | undefined> {
    return this.basePageMetaResolver.resolveBreadcrumbs();
  }

  resolveDescription(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveDescription();
  }

  resolveRobots(): Observable<PageRobotsMeta[]> {
    return this.basePageMetaResolver.resolveRobots();
  }

  resolveCanonicalUrl(options?: CanonicalUrlOptions): Observable<string> {
    return this.baseStoreFacade.getAll().pipe(
      switchMap((baseStoreList) => {
        const pathNameList = this.winRef.location.href
          .replace(this.winRef.location.origin, '')
          .split('/')
          .filter(Boolean);
        const city = baseStoreList.map((baseStore) => baseStore.code).find((code) => code === pathNameList[0]);
        if (city) {
          const canonicalPathWithoutCity = pathNameList.slice(1).join('/');

          return of(
            this.pageLinkService.getCanonicalUrl(options, this.winRef.location.origin + '/' + canonicalPathWithoutCity),
          );
        }

        return this.basePageMetaResolver.resolveCanonicalUrl(options);
      }),
    );
  }

  resolveType(): Observable<string> {
    return this.basePageMetaResolver.resolveType();
  }
}
